import config from '../config.json';
import axios from '../utils/axiosInstance';
import React, { useState } from 'react'
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@mui/material';
import joinActivityImg from '../assets/undraw_join_re_w1lh.svg';
import url from '../url.json';

export const JoinActivityForm = ({ callback_setActivities }) => {
    const userId = localStorage.getItem('userId'); 
    const [open, setOpen] = React.useState(false);
    const [data, setData] = useState({
        userId: userId,
        joinCode: ""
    });
    const [activityData, setActivityData] = useState({
        ActivityGroup:{
            Activity: {
                createdAt: '',
                endDate: '',
                title: ''
            },
            Group: {
                groupName: ''
            }
        }
    })
    
    const handleClickOpen = () => {
        setOpen(true);
    };
  
    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setData({
            ...data,
            [e.target.name]: value
        });
    };

    const handleSubmit = async (e) => { // 加上 async
        e.preventDefault();
        const activityData = {
            userId: data.userId,
        };
        try {
            await axios.put(`${url.backendHost + config.joinActivity}/${data.joinCode}/join`, activityData);

            // renew token 並存回 localStorage
            const renewRes = await axios.get(url.backendHost + config.renewToken);
            if (renewRes.data && renewRes.data.jwtToken) {
                localStorage.setItem("jwtToken", renewRes.data.jwtToken);
            }

            const fetchData = await axios.get(`${url.backendHost + config.myJoinedActivityList}/${data.userId}`);
            callback_setActivities(fetchData.data);
            console.log(`fetchdata-response: ${fetchData.data}`);
            setOpen(false);
            setData({
                userId: userId,
                joinCode: ""
            });
            
            alert("成功加入活動!");
            window.location.reload();

        } catch (error) {
            alert("加入活動失敗 請確認邀請碼!");
            if (error.response) {
                console.error("Server responded with error:", error.response);
            } else if (error.request) {
                console.error("Network error:", error.request);
            } else {
                console.error("Error:", error.message);
            }
        }
    };
  
    return (
      <div>
        <>  
            <div onClick={handleClickOpen}>
                加入活動
            </div>
        </>
        <Dialog open={open} onClose={handleClose}>
            <div>
              <img className='modal-image' src={joinActivityImg} />
            </div>
            <DialogTitle>加入探究活動</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="title"
                    label={"請輸入小組邀請碼"}
                    type="text"
                    name='joinCode'
                    value={data.joinCode}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
                <Button type='submit' onClick={handleSubmit} variant="contained">加入</Button>
            </DialogActions>
        </Dialog>
      </div>
    );
}